import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'modeWordVarys';
const args = {};

export class ModeWordVarys extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
